import { Link } from "~/components/ui/link";
import {RiArrowRightSLine} from "@remixicon/react";
import { useTranslation } from "react-i18next";
import { Button } from "~/components/ui/button";
import {
    SubnavPanelBody,
    ProductCard,
} from "~/components/header/full-header/subnavigation/common";
import { imageUrl } from "~/lib/image-url";

// Plain public/ string paths, not JS imports — see the comment on bgImageSet in
// app/components/home/UseCases.tsx for why.
const navDriveImg = imageUrl("/images/products/nav-drive.png");
const navDashcamImg = imageUrl("/images/products/nav-dashcam.png");
const navGoImg = imageUrl("/images/products/nav-go.png");

export default function ProductsNavItem({ onNavigate }: { onNavigate: () => void }) {
    const { t } = useTranslation("common");

    return (
        <SubnavPanelBody
            // size="lg" + a wider px gives this a bigger hit box than the plain default
            // link size, without changing how it looks (variant="link" has no visible
            // box, so the extra padding/height is invisible).
            footer={
                <Button asChild variant="link" size="lg" className="fleet:text-text-body-tertiary px-8 underline">
                    <Link to="/products" onClick={onNavigate}>
                        {t("subnav.products.shop_products")}
                        <RiArrowRightSLine className="h-5 w-5" />
                    </Link>
                </Button>
            }
        >
            <div className="flex items-start justify-center gap-6 lg:gap-12">
                <ProductCard
                    onNavigate={onNavigate}
                    href="/products/drive"
                    src={navDriveImg}
                    alt={t("subnav.products.drive.name")}
                    name={t("subnav.products.drive.name")}
                    description={t("subnav.products.drive.description")}
                />
                <ProductCard
                    onNavigate={onNavigate}
                    href="/products/view"
                    src={navDashcamImg}
                    alt={t("subnav.products.view.name")}
                    name={t("subnav.products.view.name")}
                    description={t("subnav.products.view.description")}
                    badge={t("subnav.products.coming_soon")}
                />
                <ProductCard
                    onNavigate={onNavigate}
                    href="/products/go"
                    src={navGoImg}
                    alt={t("subnav.products.go.name")}
                    name={t("subnav.products.go.name")}
                    description={t("subnav.products.go.description_short")}
                />
            </div>
        </SubnavPanelBody>
    );
}
